import type { ILogger } from "./logger.interface";
import { utils } from "../ui/libs/animejs";

export class Logger implements ILogger {
	private window_: Window | null = null;

	//#region For view to UI.
	bindWindowContext(window: Window): () => void {
		this.window_ = window;
		return () => {
			this.window_ = null;
		};
	}

	getUILogViewId(): string {
		return "log-view-id";
	}
	//#endregion

	log(...args: any[]): void {
		const tag = "log";
		this.logToConsole_(tag, ...args);
		this.logToUI_(tag, ...args);
	}

	info(...args: any[]): void {
		const tag = "info";
		this.logToUI_(tag, ...args);
		this.logToConsole_(tag, ...args);
	}

	warn(...args: any[]): void {
		const tag = "warn";
		this.logToUI_(tag, ...args);
		this.logToConsole_(tag, ...args);
	}

	error(...args: any[]): void {
		const tag = "error";
		this.logToUI_(tag, ...args);
		this.logToConsole_(tag, ...args);
	}

	debug(...args: any[]): void {
		const tag = "debug";
		this.logToUI_(tag, ...args);
		this.logToConsole_(tag, ...args);
	}

	private logToUI_(tag: string, ...args: any[]): void {
		const $LogView = this.window_?.document.getElementById(this.getUILogViewId());
		if (!$LogView) {
			this.logToConsole_("info", "Log to UI but Log View is not found.");
			return;
		}

		const $spans = $LogView.querySelectorAll("span");
		const date = new Date();
		const ms = utils.padStart(date.getMilliseconds(), 3, "0");
		const s = utils.padStart(date.getSeconds(), 2, "0");
		const m = utils.padStart(date.getMinutes(), 2, "0");
		const h = utils.padStart(date.getHours(), 2, "0");
		if ($spans.length > 500) {
			for (let i = 0; i < 300; i++) {
				$LogView.removeChild($spans[i]);
			}
		}
		const message = this.buildUILogMessage_(...args);
		const $el = document.createElement("span");
		$el.className = `log-line --${tag}`;
		$el.innerHTML = `${h}:${m}:${s}:${ms} ${message}<br>`;
		$LogView.appendChild($el);
		$el.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
		// $LogView.scrollTop = $LogView.scrollHeight;
	}
	private buildUILogMessage_(...args: any[]): string {
		return `${args.join(" ")}`;
	}

	private logToConsole_(tag: string, ...args: any[]): void {
		const logEmojiPrefixMap: { [idx: string]: string } = {
			log: "🍀",
			info: "💡",
			warn: "🚨",
			error: "💣",
			debug: "🔍",
		};
		const logPrefix = logEmojiPrefixMap[tag]
			? `[${logEmojiPrefixMap[tag]}#${tag}]`
			: "[#unknown]";
		console.log(`${logPrefix}: `, ...args);
	}
}

const logger = new Logger();
export default logger;
